module.exports = __webpack_public_path__ + "img/preview-lg.1cc6223c.png";